// JsFromRoutes CacheKey c2151813ca9104848bfc47b8d87c7639
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/documents/imports/xlsx'),
}
